module.exports = (state, action) => {
  const activity = action.payload
  const activityId = activity.id
  if (activity !== undefined) {
    const isNewActivity = state.activities[activityId] === undefined
    state.activities[activityId] = activity
    if (isNewActivity) { state.activitiesCount = state.activitiesCount + 1 }
  } else {
    throw new Error(`Cannot add activity with id: ${activityId}`)
  }
}
